(() => {
  const warning = ' (opens in a new tab)';
  const consentikLinks = {
    'cookies-more-info': 'Terms of Use',
    'cst-google-privacy-link': 'Privacy Policy',
    'cst-imprint-link': 'Accessibility Statement',
  };

  const patchConsentikLinks = () => {
    Object.entries(consentikLinks).forEach(([id, label]) => {
      const link = document.getElementById(id);

      if (!(link instanceof HTMLAnchorElement)) return;
      if ((link.getAttribute('target') || '').toLowerCase() !== '_blank') return;

      link.setAttribute('aria-label', `${label}${warning}`);
    });
  };

  const patchConsentikLanguageSelector = () => {
    const selector = document.querySelector('select[name="cst-language-selector"]');

    if (!(selector instanceof HTMLSelectElement)) return;
    if (selector.getAttribute('aria-label')) return;

    selector.setAttribute('aria-label', 'Select language');
  };

  const patchConsentikLanguageIcon = () => {
    const icon = document.querySelector('.ot-translation-icon');

    if (!(icon instanceof SVGElement)) return;

    icon.setAttribute('aria-hidden', 'true');
    icon.setAttribute('focusable', 'false');
    icon.removeAttribute('role');
  };

  const patchConsentikLinksWithDelay = () => {
    window.setTimeout(() => {
      patchConsentikLinks();
      patchConsentikLanguageSelector();
      patchConsentikLanguageIcon();
    }, 1000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchConsentikLinksWithDelay, { once: true });
  } else {
    patchConsentikLinksWithDelay();
  }

  new MutationObserver(patchConsentikLinksWithDelay).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['target'],
  });
})();
